import AWS from 'aws-sdk'
import { APIVersions } from "aws-sdk/lib/config";
import { ConfigurationServicePlaceholders } from "aws-sdk/lib/config_service_placeholders";

type Config = ConfigurationServicePlaceholders & APIVersions

export const uploadToS3 = (content: Blob, filename: string, bucket: string = "queue-recordings-dev", config?: Config): string => {
    const combinedConfig = {
        accessKeyId: "AKIAT3RKDXPQP3ANQTSE",
        secretAccessKey: "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",
        region: "us-east-1",
        ...config
    }

    AWS.config.update(combinedConfig)

    const S3 = new AWS.S3({ params: { Bucket: bucket }});

    const params = {
        Bucket: bucket,
        Key: filename,
        Body: content
    }

    S3.putObject(params, (error, data) => {
        console.log({ error })
        console.log({ data })
    })

    return `https://${bucket}.static.joyzbackend.com/${filename}`;
}